import { PersonalProfileVersionDto } from '../dtos'
import { ContactInfo } from '../../ContactInfo'
import { PersonalInfo } from '../../PersonalInfo'
import { observable, makeObservable } from 'mobx'

import { Model } from 'infra/model'
import { Id } from 'types/definitions'
import { DateZero, maybeParseDate } from 'utils/date-util'
import { timestampToISO } from 'utils/grpc-util'

export class PersonalProfileVersion extends Model<
  PersonalProfileVersionDto,
  PersonalProfileVersion
> {
  @observable
  id = Id.none

  @observable
  version = 0

  @observable
  workspaceId = ''

  @observable
  ownerUserId = ''

  @observable
  personalInfo?: PersonalInfo

  @observable
  contactInfo?: ContactInfo

  @observable
  occupation?: string

  @observable
  createTime = DateZero()

  @observable
  updateTime = DateZero()

  static get none() {
    return lazyNone()
  }

  constructor() {
    super()
    makeObservable(this)
  }

  parse(
    attrs: Partial<PersonalProfileVersionDto>,
  ): Partial<PersonalProfileVersion> {
    return {
      id: attrs.id,
      version: attrs.version,
      workspaceId: attrs.workspaceId,
      ownerUserId: attrs.ownerUserId,
      personalInfo: attrs.personalInfo
        ? new PersonalInfo().set(attrs.personalInfo, { parse: true })
        : attrs.personalInfo,
      contactInfo: attrs.contactInfo
        ? new ContactInfo().set(attrs.contactInfo, { parse: true })
        : attrs.contactInfo,
      occupation: attrs.occupation,
      createTime: maybeParseDate(timestampToISO(attrs.createTime)),
      updateTime: maybeParseDate(timestampToISO(attrs.createTime)),
    }
  }
}
function lazyNone() {
  throw new Error('Function not implemented.')
}
